module.exports = __webpack_public_path__ + "img/DE00601.737fdd64.png";